import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Card, CardContent, Dialog, DialogContent, Icon, Stack, Typography } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { darkBlue } from 'utils/constants/ColorTheme'

const IntegrationModeDialog = ({
    quality,
}) => {
    const [open, setIsOpen] = useState(false)

    return (
        <>
            <Icon
                style={{
                    fontSize: 14,
                    position: 'relative',
                    top: '-49px',
                    left: '214px',
                }}
                tooltip={'Description des options'}
                onClick={() => setIsOpen(true)}
            >help</Icon>
            <Dialog open={open} maxWidth='md'>
                <DefaultDialogTitle title={'Modes d\'intégration'} onClose={() => setIsOpen(false)}/>
                <DialogContent>
                    <Stack spacing={1}>
                        <Card>
                            <CardTitle color={darkBlue} title={ 'Ne pas intégrer de données' } />
                            <CardContent>
                                <Typography>N'intègre aucune données. C'est utilisé par exemple sur l'export Ades afin d'importer uniquement la description de la station, sans les mesures.</Typography>
                            </CardContent>
                        </Card>
                        <Card>
                            <CardTitle color={darkBlue} title={i18n.lastDataIntegration} />
                            <CardContent>
                                <Typography>N'intègre que les données dont la date/heure se situe après la dernière mesure de la chronique.</Typography>
                            </CardContent>
                        </Card>
                        <Card>
                            <CardTitle color={darkBlue} title={i18n.replaceHistoIntegration} />
                            <CardContent>
                                <Typography>Supprime tout l'historique et intègre tout le fichier. A utiliser avec parcimonie ! (dans le cas de tests par exemple).</Typography>
                            </CardContent>
                        </Card>
                        <Card>
                            <CardTitle color={darkBlue} title={i18n.addOnlyNewsDataIntegration} />
                            <CardContent>
                                <Typography>N'ajoute que les mesures dont la date/heure n'est pas déjà présente en base. (C'est le mode par défaut, qui est utilisé si aucun mode d'import n'est sélectionné)</Typography>
                            </CardContent>
                        </Card>
                        { quality ? (
                            <Card>
                                <CardTitle color={darkBlue} title={i18n.replaceDataIntegration} />
                                <CardContent>
                                    <Typography>Remplace les opérations déjà existantes par celles qui sont dans le fichier. (Ne supprime pas celles qui ne sont pas dans le fichier)</Typography>
                                </CardContent>
                            </Card>
                        ) : (
                            <Card>
                                <CardTitle color={darkBlue} title={i18n.replaceDataIntegration} />
                                <CardContent>
                                    <Typography>Supprime en base les données dont la date/heure se situe entre la date/heure de la première mesure du fichier et la date/heure de la dernière mesure du fichier. Cela peut servir pour repasser des fichiers qui ont été corrigés.</Typography>
                                </CardContent>
                            </Card>
                        ) }
                        <Card>
                            <CardTitle color={darkBlue} title={i18n.replaceRecentHisto} />
                            <CardContent>
                                <Typography>Avant d'intégrer les données, supprime toutes les données entre aujourd'hui et aujourd'hui moins X mois (avec X la valeur du champ "Période de remplacement"). Pour les traitements qualité OpenData, cela permet de se synchroniser de manière plus fiable avec la banque de données sans pour autant récupérer tout l'historique à chaque fois (et donc avoir un traitement qui dure moins longtemps).</Typography>
                            </CardContent>
                        </Card>
                        <Typography>La méthode choisie sera appliquée une fois par type de donnée. Par exemple, si dans le fichier il y a à la fois de la profondeur et de la température, et que le mode "Remplacer les données" a été choisi, l'import va remplacer les données de profondeur en base en regardant les dates de la première mesure de profondeur du fichier et la dernière mesure de profondeur. Ensuite il va remplacer les données de température en base en regardant les dates de la première mesure de température du fichier et la dernière mesure de température du fichier, etc...</Typography>
                    </Stack>
                </DialogContent>
            </Dialog>
        </>
    )
}

IntegrationModeDialog.propTypes = {
    quality: PropTypes.bool,
}

export default IntegrationModeDialog